import { render, staticRenderFns } from "./SituacoesPorMes.vue?vue&type=template&id=766ea4e4&lang=pug&"
import script from "./SituacoesPorMes.vue?vue&type=script&lang=js&"
export * from "./SituacoesPorMes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports